import Button from 'react-md/lib/Buttons/Button';
import './styles.module.scss';

export default Button;
